/**
 * `wpp::pagination`
 *
 * Clamping lives here rather than on the server so that a typed page number is
 * corrected as it is typed, without a round trip. The component only tells the
 * outside world about a page that actually changed, so a Livewire listener is
 * not re-fetching the page it is already showing.
 *
 * @param {{ currentPage?: number, lastPage?: number }} options
 */
export default (options = {}) => ({
    current: options.currentPage ?? 1,
    last: options.lastPage ?? 1,

    go(page) {
        const next = Math.min(Math.max(1, parseInt(page, 10) || 1), this.last);

        if (next === this.current) {
            // Still correct the input, which may hold something out of range.
            this.$dispatch('pagination-clamped', { page: next });

            return;
        }

        this.current = next;
        this.$dispatch('page-changed', { page: next });
    },

    get isFirst() {
        return this.current <= 1;
    },

    get isLast() {
        return this.current >= this.last;
    },
});
